export const bzAgendaLocations = [
    {
        "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
        "name": "summit-stage",
        "value": "summit-stage"
    },
    {
        "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
        "name": "future-stage",
        "value": "future-stage"
    },
    {
        "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
        "name": "exhibition-stage",
        "value": "exhibition-stage"
    },
    {
        "id": "RmllbGRWYWx1ZV8xOTgzMTg2Nw==",
        "name": "inspiration-workshop-room",
        "value": "inspiration-workshop-room"
    },
    {
        "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
        "name": "workshop-room",
        "value": "workshop-room"
    },
    {
        "id": "RmllbGRWYWx1ZV8yMjU3Nzc5NQ==",
        "name": "yanbu-workshop-room",
        "value": "yanbu-workshop-room"
    },
    {
        "id": "RmllbGRWYWx1ZV8yMzQ0NjQwMA==",
        "name": "al-omsiat-b",
        "value": "al-omsiat-b"
    },
    {
        "id": "RmllbGRWYWx1ZV8yMjU3ODg2Ng==",
        "name": "mansard-riyadh-a-radisson-collection-hotel",
        "value": "mansard-riyadh-a-radisson-collection-hotel"
    },
    {
        "id": "RmllbGRWYWx1ZV8yMzMyODI4NA==",
        "name": "main-conference-room",
        "value": "main-conference-room"
    },
    {
        "id": "RmllbGRWYWx1ZV8yMzMyODI4Ng==",
        "name": "workshop-room-1",
        "value": "workshop-room-1"
    },
    {
        "id": "RmllbGRWYWx1ZV8yMzMyODMzNg==",
        "name": "workshop-room-2",
        "value": "workshop-room-2"
    },
    {
        "id": "RmllbGRWYWx1ZV8yMzMyODM1NQ==",
        "name": "exhibition-hall",
        "value": "exhibition-hall"
    }
]